import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { suppressHydrationErrors } from './utils/consoleFilter';

// Suppress hydration error messages in console
suppressHydrationErrors();

const root = ReactDOM.createRoot(document.getElementById('root'));

// Modo mantenimiento controlado por variable de entorno
const maintenance = String(process.env.REACT_APP_MAINTENANCE || '').toLowerCase() === 'true';

function MaintenanceScreen() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0d1117', color: '#fff', textAlign: 'center', margin: 0
    }}>
      <h1>🚧 Emparqueo Amigo en mantenimiento</h1>
      <p>Estamos realizando mejoras en el sistema. Volveremos en breve.</p>
    </div>
  );
}

root.render(
  <React.StrictMode>
    {maintenance ? <MaintenanceScreen /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
